import { AxiosResponse } from 'axios'

import { _axios } from './axios'

const CURRENT_PROMPT = '/instruction-prompts/current'
const CREATE_PROMPT = '/instruction-prompts'

export type InstructionPrompt = {
  id: string
  promptTemplate: string
  recentSituationDesc: string
  nextCheckPointsDesc: string
  longTermTrendDesc: string
  createdBy: string | null
  savedAt: string
}

export type CreatePromptRequest = {
  promptTemplate: string
  recentSituationDesc: string
  nextCheckPointsDesc: string
  longTermTrendDesc: string
}

export const instructionPromptApi = () => {
  const getCurrent = async (): Promise<AxiosResponse<InstructionPrompt>> => {
    return await _axios().get(CURRENT_PROMPT)
  }

  const create = async (
    data: CreatePromptRequest,
  ): Promise<AxiosResponse<void>> => {
    return await _axios().post(CREATE_PROMPT, data)
  }

  return {
    getCurrent,
    create,
  }
}
